import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'm-doc-card',
  template: `
    <nz-card class="m-statistics-doc-card" nzBordered="false">
      <div nz-row nzType="flex" nzAlign="top">
        <div nz-col class="m-statistics-doc-card-icon">
          <div class="m-statistics-doc-card-icon-content">
            <img *ngIf="mImg" [attr.src]="mImg" />
            <span *ngIf="!mImg" class="m-statistics-doc-card-icon-font" [style.backgroundColor]="getRandomColor(mTitle)">
              {{ mTitle[0] }}
            </span>
          </div>
        </div>
        <div nz-col>
          <span class="m-statistics-doc-card-desc">
            {{ mTitle }}
          </span>
          <span class="m-statistics-doc-card-intro">
            {{ mDescription }}
          </span>
        </div>
      </div>
    </nz-card>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  preserveWhitespaces: true
})
export class DocCardComponent {
  @Input() mImg = '';
  @Input() mTitle = '';
  @Input() mDescription = '';
  @Input() mColorList = ['#3079D9', '#5FB333', '#F38900', '#F6AC00', '#5F3DC4', '#1098AD', '#4263EB', '#F25020', '#2EB38D', '#00B8EE'];

  getRandomColor(name: string): string {
    return this.mColorList[name.charCodeAt(0) % this.mColorList.length];
  }
}
